import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'src/app/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class BookingHistoryService {

  constructor(public apiService: ApiService) { }

  public fetchBookingHistory(searchQuery: any): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'fetchBookingHistory',
      type: 'GET',
      queryParams: searchQuery
    });
  }
}
